import { forOwn } from 'lodash';
import { maxInt } from '../helpers';
import map from '../parser/parser-map';

const resultMap = map.match.result;

export class Result {
  constructor(rawObj) {
    this.value = rawObj[resultMap.value];
    this.providerId = rawObj[resultMap.providerId];
  }
}

const categoryMap = map.category;

export class Category {
  constructor(raswCategory) {
    this.id = raswCategory[categoryMap.id];
    this.idSport = raswCategory[categoryMap.idSport];
    this.name = raswCategory[categoryMap.name];
    this.isoName = raswCategory[categoryMap.isoName];
  }
}

const matchMap = map.match;

export class Match {
  constructor(rawObj) {
    this.id = rawObj[matchMap.id];
    this.name = rawObj[matchMap.name];
    this.idSport = rawObj[matchMap.idSport];
    this.idTournament = rawObj[matchMap.idTournament];
    this.results = rawObj[matchMap.results];
    this.timestamp = rawObj[matchMap.timestamp];

    this.parseResults();
    this.setWinner();
  }

  parseResults() {
    const results = {};
    if (this.results) {
      this.results = forOwn(this.results, (value) => {
        const result = new Result(value);
        results[result.providerId] = result;
      });
    }
    this.results = results;
  }

  setWinner() {
    if (!this.results || !this.results.FT) {
      this.winner = null;
      return;
    }

    const finalResults = this.results.FT.value.split(':');
    if (finalResults[0] > finalResults[1]) {
      this.winner = 0;
    } else if (finalResults[1] > finalResults[0]) {
      this.winner = 1;
    } else {
      this.winner = null;
    }
  }
}

const sportMap = map.sport;

export class Sport {
  constructor(rawSport) {
    this.id = rawSport[sportMap.id];
    this.name = rawSport[sportMap.name];
    this.providerId = rawSport[sportMap.providerId];
  }
}

export class Tournament {
  constructor(rawTournament) {
    this.id = rawTournament[map.tournament.id];
    this.idSport = rawTournament[map.tournament.idSport];
    this.idCategory = rawTournament[map.tournament.idCategory];
    this.name = rawTournament[map.tournament.name];
    this.shortName = rawTournament[map.tournament.shortName] || this.name;
    this.position = parseInt(rawTournament[map.tournament.position], 10) || maxInt;
    this.topTournament = !!rawTournament[map.tournament.topTournament];
    this.providerId = rawTournament[map.tournament.providerId];
  }
}

export default {
  Category,
  Match,
  Result,
  Sport,
  Tournament,
};
